import _checkPrivateRedeclaration from "./checkPrivateRedeclaration.js";
//#region \0@oxc-project+runtime@0.151.0/helpers/esm/classPrivateFieldInitSpec.js
function _classPrivateFieldInitSpec(e, t, a) {
	_checkPrivateRedeclaration(e, t), t.set(e, a);
}
//#endregion
export { _classPrivateFieldInitSpec as default };
